// src/app/my-theme.ts
// Appackshadow-Bibliothek: https://getcssscan.com/css-box-shadow-examples
// PrimeUIX: https://github.com/primefaces/primeuix/tree/main/packages/themes/src/presets/aura


import { getAppackThemeDefault } from 'core-ui';


export const whiteButton = {
    root: {
        borderRadius: '0',
    },
    colorScheme: {
        light: {
            root: {
                primary: {
                    background: '{surface.0}',
                    hoverBackground: '{surface.0}',
                    activeBackground: '{secondary.500}',
                    borderColor: '{surface.0}',
                    hoverBorderColor: '{secondary.500}',
                    activeBorderColor: '{secondary.500}',
                    color: '{secondary.500}',
                    hoverColor: '{secondary.500}',
                    activeColor: '{surface.0}',
                    focusRing: {
                        color: '{secondary.950}',
                        shadow: 'none'
                    }

                }
            }
        }
    }
};

export const whiteButtonLast = {
    root: {
        borderRadius: '0 6px 6px 0',
    },
    colorScheme: {
        light: {
            root: {
                primary: {
                    background: '{surface.0}',
                    hoverBackground: '{surface.0}',
                    activeBackground: '{secondary.500}',
                    borderColor: '{surface.0}',
                    hoverBorderColor: '{secondary.500}',
                    activeBorderColor: '{secondary.500}',
                    color: '{secondary.500}',
                    hoverColor: '{secondary.500}',
                    activeColor: '{surface.0}',
                    focusRing: {
                        color: '{secondary.950}',
                        shadow: 'none'
                    }

                }
            }
        }
    }
};

export const whiteButtonActive = {
    root: {
        borderRadius: '0',
    },
    colorScheme: {
        light: {
            root: {
                primary: {
                    background: '{secondary.500}',
                    hoverBackground: '{secondary.500}',
                    activeBackground: '{secondary.500}',
                    borderColor: '{surface.0}',
                    hoverBorderColor: '{secondary.500}',
                    activeBorderColor: '{secondary.500}',
                    color: '{surface.0}',
                    hoverColor: '{surface.0}',
                    activeColor: '{surface.0}',
                    focusRing: {
                        color: '{secondary.950}',
                        shadow: 'none'
                    }

                }
            }
        }
    }
};

export const whiteButtonLastActive = {
    root: {
        borderRadius: '0 6px 6px 0',
    },
    colorScheme: {
        light: {
            root: {
                primary: {
                    background: '{secondary.500}',
                    hoverBackground: '{secondary.500}',
                    activeBackground: '{secondary.500}',
                    borderColor: '{surface.0}',
                    hoverBorderColor: '{secondary.500}',
                    activeBorderColor: '{secondary.500}',
                    color: '{surface.0}',
                    hoverColor: '{surface.0}',
                    activeColor: '{surface.0}',
                    focusRing: {
                        color: '{secondary.950}',
                        shadow: 'none'
                    }

                }
            }
        }
    }
};

export const appointmentCard = {
    body: {
        padding: '0px',
    }
};

export function getAppackTheme() {
    /**
     * Hier ist Platz für Custom Logik
     */
    return getAppackThemeDefault();
}
